import meta from '../metas/number-range';
export default {
  meta,
  computed: {
    min() {
      const val = this.$attrs.value || [];
      return val[0] || '';
    },

    max() {
      const val = this.$attrs.value || [];
      return val[1] || '';
    }

  },
  methods: {
    handleMin(value) {
      const val = this.$attrs.value || [];
      this.$emit('input', [+value, val[1] || '']);
    },

    handleMax(value) {
      const val = this.$attrs.value || [];
      this.$emit('input', [val[0] || '', +value]);
    }

  }
};